import React from "react";
import AttendanceRecord from "./AttendanceRecord";

const DepartmentList = ({
  departments,
  fetchAttendanceDetail,
  summaryDate,
  attendance,
  staffs,
  baseUrl,
  openToast,
  setSelectedStaff,
}) => {
  console.log(attendance);
  console.log(departments.map((d) => (attendance?.filter((a) => a?.staffDetails?.department?.id === d?.id))));
  return (
    <>
      {departments?.map((d) => {
        const rec = attendance?.filter(
          (a) => a?.staffDetails?.department?.id === d?.id
        );


        return (
          <div key={d.id} className="flex flex-col gap-[10px] mt-[10px]">
            {rec?.length > 0 && d?.department_name ? (
              <h2 className="flex items-center gap-[10px] font-medium">
                {d?.department_name}
                <span className="bg-[#27004a] px-[8px] py-[1px] rounded-full font-medium text-[14px] text-white">
                  {rec?.length}
                </span>
              </h2>
            ) : null}
            {rec?.map((item, index) => (
              <AttendanceRecord
                key={index}
                item={item}
                staffs={staffs}
                baseUrl={baseUrl}
                openToast={openToast}
                setSelectedStaff={setSelectedStaff}
                summaryDate={summaryDate}
                fetchAttendanceDetail={fetchAttendanceDetail}
              />
            ))}
          </div>
        );
      })}
    </>
  );
};

export default DepartmentList;